import { gql } from "@lytra/frontend-common/__generated__";

// "An Kollegen senden" (#717). Every operation is named TicketForward*
// because operation names are unique across the monorepo's shared generated registry.

// The selection is what the send entry in the thread renders (plan 11), so the cache
// already holds the new row when the ticket refetches. Server refusals arrive as GraphQL
// errors with a German message and `extensions.code` (FORWARD_MESSAGE_GONE, FORWARD_TOO_LARGE,
// FORWARD_INVALID, FORWARD_KEY_REUSED, FORWARD_MAIL_UNAVAILABLE), see forwardDraft.ts.
export const TICKET_FORWARD_TO_COLLEAGUES = gql(`
  mutation TicketForwardToColleagues(
    $conversationId: UUID!
    $messageId: UUID!
    $recipients: [ForwardRecipientInput!]!
    $clientRequestId: UUID!
    $text: String! = ""
    $includeAttachments: Boolean! = true
    $signatureHtml: String = null
    $includeInternalMessages: Boolean! = false
    $includeInternalNotes: Boolean! = false
  ) {
    forwardToColleagues(
      conversationId: $conversationId
      messageId: $messageId
      recipients: $recipients
      clientRequestId: $clientRequestId
      text: $text
      includeAttachments: $includeAttachments
      signatureHtml: $signatureHtml
      includeInternalMessages: $includeInternalMessages
      includeInternalNotes: $includeInternalNotes
    ) {
      id
      isForward
      isInternal
      direction
      forwardedMessageId
      forwardMailStatus
      forwardMailFailureReason
      emailMseMailboxUserPrincipalName
      forwardRecipients {
        kind
        userId
        label
        address
        isExternal
      }
      forwardRequestStates {
        userId
        status
      }
      contentText
      receivedAt
      agent {
        id
        givenName
        familyName
      }
    }
  }
`);

// The tenant's own mail domains: a "per Mail" address outside them gets the inline warning
// (D-10). Readable by any agent. A failed load means no chip warns.
export const TICKET_FORWARD_TENANT_DOMAINS = gql(`
  query TicketForwardTenantDomains {
    tenant {
      id
      internalDomains
    }
  }
`);

// Whether a send may leave Lytra by mail. While false the server refuses every address that is
// not a colleague (FORWARD_MAIL_UNAVAILABLE) and the composer offers colleagues only.
export const TICKET_FORWARD_MAIL_ENABLED = gql(`
  query TicketForwardMailEnabled {
    forwardMailEnabled
  }
`);
